module.exports = {
  title: "case management system",
  login: {
    user: "user",
    password: "password",
    userFreeze: "user frozen",
    autoLogin: "automatically login within two weeks",
    forgetPwd: "forgot password?",
    loginBtn: "sign in",
    userNameOrPwdEmpty: "username or password cannot be empty",
    errorDesc: "incorrect username or password",
    namePlaceholder: "please enter your account",
    pwdPlaceholder: "please input a password"
  },
  patientMessage: {
    status: {
      "0": "data missing",
      "4": "STL pending",
      "6": "express tracking number to be filled in",
      "8": "pending upload",
      "10": "pending acceptance",
      "11": "technician supervisor rejects",
      "12": "pending assignment",
      "15": "model processing",
      "18": "designing",
      "20": "DIY solution manufacturer verification",
      "21": "DIY solution rejected by manufacturer",
      "24": "pending expert’s verification",
      "25": "expert rejection",
      "27": "doctor verification",
      "28": "doctor rejects",
      "30": "pending verification",
      "32": "DIY prod verication",
      "33": "DIY plan production rejected",
      "35": "prepare for production",
      "37": "producing",
      "40": "shipping",
      "42": "delivery completed, awaiting next",
      "44": "delivered",
      "46": "restarted",
      "50": "completed"
    },
    statusFinish: {
      "0": "the clinical situation has been improved",
      "4": "STL uploaded",
      "6": "the tracking number has been filled in",
      "8": "case submitted",
      "10": "case accepted",
      "11": "reviewer has rejected",
      "12": "case assigned",
      "15": "model processing completed",
      "18": "plan design completed",
      "20": "DIY solution manufacturer verification completed",
      "21": "the DIY solution manufacturer has rejected it",
      "24": "plan approved by expert",
      "25": "expert has rejected",
      "27": "plan approved by doctor",
      "28": "the doctor has rejected it",
      "30": "produce order submitted",
      "32": "plan verified",
      "33": "the DIY plan production has been rejected",
      "35": "producing",
      "37": "production completed",
      "40": "shipping",
      "42": "delivery completed, awaiting next",
      "44": "delivered",
      "46": "restarted",
      "50": "completed"
    },
    patientMes: {
      is_crowded: "crowded",
      is_interval: "sparse",
      is_II_I: "class II, division 1",
      is_II_II: "class II, division 2",
      is_III: "class III",
      is_opening_and_closing: "open bite",
      is_anterior_crossbite: "anterior crossbite",
      is_posterior_teeth: "posterior crossbite ",
      is_deep_draping: "overbite",
      is_deep_overjet: "overjet",
      is_both_edge: "edge-to-edge bite",
      is_expanal_dental_arch: "narrow dental arch",
      is_gagtooth: "protrusion",
      is_smile_line_not_neat: "inadequate smile line",
      is_tooth_abnormlities: "deformed teeth",
      is_other: "other",
      is_periodontal: "gingival inflammation",
      is_osteoporosis: "osteoporosis",
      is_inflammation: "oral inflammation",
      is_tmj_problems: "TMJ disorders"
    },
    reason: "reason",
    caseNumber: "case ID",
    orderNumber: "batch number",
    hasNoData: "this medical record has not yet uploaded data",
    hasSentOut: "sent out by express delivery",
    trackNum: "logistics tracking number",
    newCaseId: "new case ID:",
    oldCaseId: "original case ID:",
    distributed: "assign technicians：",
    caseFile: "case created",
    emailInfo: "send email"
  },
  common: {
    modifyBtn: "edit",
    edit: "edit",
    save: "save",
    okBtn: "ok",
    confirm: "confirm",
    downLoad: "download",
    cancelBtn: "cancel",
    retreatBtn: "retreat",
    backBtn: "return",
    tempStorageBtn: "temporarily store",
    prePage: "previous page",
    nextPage: "next page",
    quitBtn: "exit",
    submitBtn: "submit",
    delBtn: "delete",
    createBtn: "create",
    delTitle: "are you sure you want to delete it?",
    delContent: "click done to delete, please proceed with caution!",
    reminder: "prompt",
    delSuccess: "delete successfully",
    CompleteBtn: "complete",
    hasSignOut: "you have logged out",
    rejectRemarks: "comments",
    mesContent: "this case is no longer eligible for this operation",
    notNull: "cannot be empty",
    Pselect: "please select",
    Pinput: "please input",
    required: "required items cannot be blank",
    length800: "please enter (within 800 words)",

    validateText: {
      account: "please enter the correct account/cell-phone number",
      address: "the address cannot contain illegal characters",
      password: "please enter 6-32-bit characters",
      // password: '请输入6-20位数字和字母组合',
      rePassword: "the password entered twice is inconsistent",
      phone: "please enter the correct phone number",
      email: "please enter the correct email address",
      name: [
        "name is illegal,Please enter Chinese characters or letters",
        "the name is too long and cannot exceed 60 characters"
      ]
    },
    numberInput: "please enter a number",
    total: "total",
    items: "strip",
    jumpTo: "jump to",
    page: "page",
    prev: "previous page",
    next: "next page",
    commitCase: "submit",
    backToPatientList: "return to Case List",
    backToPatientMessage: "return to the case details page",
    shareToPatient: "case sharing"
  },
  userMessage: {
    title: "personal center",
    addAddress: "add mailing address",
    modalTitle: "add mailing address",
    modalTitle1: "edit mailing address",
    modalNewAddIntro:
      "establish a new address to receive orthodontic instruments or related documents",
    userInfoLabel: [
      "user profile picture",
      "account number",
      "password",
      "phone number",
      "e-mail",
      "mailing address",
      "address"
    ],
    noData: "no data available at the moment",
    recipientsText: [
      {
        label: "recipient Name",
        placeholder: "please enter the recipient's name",
        validateMsg: "the recipient's name cannot be empty"
      },
      {
        label: "TELEPHONE",
        placeholder: "mobile phone number, landline, extension, etc",
        validateMsg1: "the recipient's phone number cannot be empty",
        validateMsg2: "please provide the correct recipient phone number"
      },
      {
        label: "recipient address",
        placeholder:
          "please enter the recipient's address, including the house number",
        validateMsg: "the recipient's address cannot be empty"
      },
      {
        label: "postal code",
        placeholder: "please enter the postal code of your location",
        validateMsg1: "postal code cannot be empty",
        validateMsg2: "please fill in the correct postal code"
      },
      {
        label: "hospital/clinic",
        placeholder: "please enter",
        validateMsg: "hospital/clinic cannot be empty"
      }
    ],
    noticeMsgErr: "please provide complete and accurate information",
    addMsgSuccess: "successfully added address",
    updateMsgSuccess: "address modification successful",
    delMsgSuccess: "successfully deleted address",
    editPassword: {
      title: [
        "edit password",
        "please enter your original login password.",
        "please set your new login password."
      ],
      placeholder: [
        "original password",
        "password",
        "enter the new password again"
      ],
      step: ["enter original password", "enter new password"]
    },
    editPhone: {
      title: [
        "edit phone number",
        "enter your new phone number and verify to modify the number."
      ],
      placeholder: ["phone number", "fill in the verification code"],
      step: ["enter new number", "verify"]
    },
    editEmail: {
      title: ["edit email address", "enter a new email address."],
      placeholder: "email address"
    },
    responseText: [
      "this phone number has already been registered",
      "verification code has been sent",
      "modified successfully",
      "modification failed"
    ],
    selectBtn: ["re elect", "ok"],
    hint: "click or drag the image here, supports JPG, PNG and other formats",
    preview: "avatar Preview"
  },
  //诊断信息页面
  clinicalSetting: {
    title: "clinical situation",
    remarks: "doctor's treatment plan",
    remarks_footer:
      "comments: technician shall design according to doctor’s treatment plan if conflicts occur against options selected.",
    clinicalSetting: [
      {
        id: "is_crowded",
        label: "crowding",
        value: 1
      },
      {
        id: "is_interval",
        label: "sparse",
        value: 2
      },
      {
        id: "is_deep_draping",
        label: "overbite",
        value: 3
      },
      {
        id: "is_deep_overjet",
        label: "overjet",
        value: 4
      },
      {
        id: "is_II_I",
        label: "class II, division 1",
        value: 5
      },
      {
        id: "is_II_II",
        label: "class II, division 2",
        value: 6
      },
      {
        id: "is_III",
        label: "class III",
        value: 7
      },
      {
        id: "is_both_edge",
        label: "edge-to-edge bite",
        value: 8
      },
      {
        id: "is_opening_and_closing",
        label: "open bite",
        value: 9
      },
      {
        id: "is_anterior_crossbite",
        label: "anterior crossbite",
        value: 10
      },
      {
        id: "is_posterior_teeth",
        label: "posterior crossbite ",
        value: 11
      },
      {
        id: "is_expanal_dental_arch",
        label: "narrow dental arch",
        value: 12
      },
      {
        id: "is_periodontal",
        label: "gingival inflammation",
        value: 13
      },
      {
        id: "is_inflammation",
        label: "oral inflammation",
        value: 14
      },
      {
        id: "is_osteoporosis",
        label: "osteoporosis",
        value: 15
      },
      {
        id: "is_tmj_problems",
        label: "TMJ disorders",
        value: 16
      },
      {
        id: "is_gagtooth",
        label: "protrusion",
        value: 17
      },
      {
        id: "is_smile_line_not_neat",
        label: "inadequate smile line",
        value: 18
      },
      {
        id: "is_tooth_abnormlities",
        label: "deformed teeth",
        value: 19
      }
    ]
  },
  /**隐形**/
  transparent: {
    correctionMethodContent: "treatment",
    correctionOpts: [
      {
        value: 21,
        label: "molar distalization"
      },
      {
        value: 22,
        label: "molar mesialization"
      },
      {
        value: 23,
        label: "IPR"
      },
      {
        value: 24,
        label: "anterior intrusion"
      },
      {
        value: 25,
        label: "posterior intrusion"
      },
      {
        value: 26,
        label: "anterior extrusion"
      },
      {
        value: 27,
        label: "posterior extrusion"
      },
      {
        value: 28,
        label: "anterior teeth proclination"
      },
      {
        value: 29,
        label: "bite guard"
      },
      {
        value: 30,
        label: "arch constriction"
      },
      {
        value: 31,
        label: "posterior lingual inclination"
      },
      {
        value: 32,
        label: "posterior buccal inclination"
      },
      {
        value: 33,
        label: "derotation"
      },
      {
        value: 34,
        label: "class III elastics"
      },
      {
        value: 35,
        label: "extraction of third molars"
      }
    ],
    archTreatment: "proposed dental arch arrangement",
    archTreatmentOpts: [
      {
        value: 1,
        label: "complete"
      },
      {
        value: 2,
        label: "maxillary"
      },
      {
        value: 3,
        label: "mandibular"
      }
    ],
    exToothTitle: "tooth extraction/non-extraction",
    extTooth: ["tooth extraction", "non-extraction"],
    Anchorage: "anchorage",
    anchorage: [
      "strong: maintain lost orientation of posterior teeth",
      "middle: 1/3 of anterior gap of posterior teeth",
      "weak: 1/2 of anterior gap of posterior teeth"
    ],
    maxilla: "maxillary",
    mandible: "mandibular",
    midline: "center line",
    adjustment: ["maintain", "improve"],
    midlineOpts: [
      {
        name: "left adjustment",
        label: "2"
      },
      {
        name: "right adjustment",
        label: "3"
      }
    ],
    overbite: "overbite",
    overlayData: [
      {
        value: "1",
        label: "anterior intrusion of both",
        children: [
          {
            value: "1",
            label: "normal"
          },
          {
            value: "2",
            label: "I degree deep overbite"
          },
          {
            value: "3",
            label: "II degree deep overbite"
          },
          {
            value: "4",
            label: "III degree deep overbite"
          }
        ]
      },
      {
        value: "2",
        label: "anterior intrusion of maxillary",
        children: [
          {
            value: "1",
            label: "normal"
          },
          {
            value: "2",
            label: "I degree deep overbite"
          },
          {
            value: "3",
            label: "II degree deep overbite"
          },
          {
            value: "4",
            label: "III degree deep overbite"
          }
        ]
      },
      {
        value: "3",
        label: "anterior intrusion of mandibular",
        children: [
          {
            value: "1",
            label: "normal"
          },
          {
            value: "2",
            label: "I degree deep overbite"
          },
          {
            value: "3",
            label: "II degree deep overbite"
          },
          {
            value: "4",
            label: "III degree deep overbite"
          }
        ]
      }
    ],
    cover: "overjet",
    coverdownList: [
      {
        name: "normal",
        label: "2"
      },
      {
        name: "mild",
        label: "3"
      },
      {
        name: "moderate",
        label: "4"
      },
      {
        name: "severe",
        label: "5"
      }
    ],
    adjustmentDirection: ["left", "right"],
    molarRelation: "molar relationship ",
    molarRelationList: [
      {
        name: "neutral",
        label: "2"
      },
      {
        name: "mesial",
        label: "3"
      },
      {
        name: "distal",
        label: "4"
      }
    ],
    crowdings: "dental crowding",
    crowdingsChoice: ["maintain", "relieve"],
    crowdingsOpts: [
      {
        name: "arch expansion",
        label: "1"
      },
      {
        name: "IPR",
        label: "2"
      },
      {
        name: "buccal expansion",
        label: "3"
      },
      {
        name: "molars distalization",
        label: "4"
      }
    ],
    moveAngle: "step translation & rotation",
    move: "movement",
    angle: "angle",
    moveOptions: [
      /*{
        value: '距离',
        label: '0'
      },*/
      {
        value: "0.15mm",
        label: "1"
      },
      {
        value: "0.2mm",
        label: "2"
      },
      {
        value: "0.25mm",
        label: "3"
      }
    ],
    angleOptions: [
      /*{
        value: '角度',
        label: '0'
      },*/
      {
        value: "1°",
        label: "1"
      },
      {
        value: "2°",
        label: "2"
      },
      {
        value: "3°",
        label: "3"
      }
    ],
    unknown: "unknown",
    photoShow: "current case image reference",
    removable: "tooth movement restrictions",
    adhesive: "attachment restrictions",
    reserved: "reserved gap required tooth position",
    enamel: "non- IPR tooth position",
    corrected: "orthodontic treatment",
    correctedNeed: ["need", "no need"],
    adhesiveChoice: ["default attachment position", "non-attachment position"],
    adhesivePrompt:
      "if the default attachment position is selected, the technician will bond the attachment according to the case situation",
    adhesiveBtn: "determine",
    adhesiveInfoPrompt: "*please refer to all the attached information below*",
    adhesiveInfoHead: [
      "attachment number",
      "attachment type",
      "functional situation",
      "attachment Name"
    ],
    adhesiveInfo: [
      "long distance movement of anterior teeth and root rotation control",
      "optimization of the fixation effect of long-distance movement and root control rotation of anterior teeth compared to ordinary D-type attachments",
      "used for long-distance translation and fixation of teeth",
      "used for anterior tooth depression and fixation",
      "used for anterior and posterior teeth fixation to prevent appliance dislocation",
      "used for anterior tooth elongation",
      "used for elongation of premolars"
    ],
    attachmentNameList: [
      "twist attachment",
      "twist the fixing attachment",
      "vertical rectangle",
      "horizontal rectangle",
      "elliptical attachment",
      "wedge shaped attachment",
      "extended attachment"
    ],
    adhesiveInfoChoice: "* the number of attachments cannot exceed three"
  },
  dataUpload: {
    fileUpload: "dental data",
    chooseFile: "select file",
    downloadBtn: "click to download the file",
    maxillaryMod: "maxillary digital model",
    mandibleMod: "mandibular digital model",
    clickReUpload: "click to re-upload",
    fileFormat: "STL file only",

    correctPlan: "upload orthodontic treatment plan",
    otherFileUpLoad: "upload other files",
    uploadClickCancel: "uploading...click to cancel",
    uploadFileText: "upload failed, please try again!",
    fileUploadingText:
      "the file is currently being uploaded. Are you sure you want to leave this page?",
    uploadSuccess: "upload successful",
    fileFormatErr: "the file format is incorrect",
    file: "file",
    formatErrText: " the format is incorrect.",
    selectPlan: "please select clinical situation",
    uploadBtn: "click to select file upload",
    modalTitle: "prompt",
    modalContent:
      "please upload a digital model or enter a valid tracking number",
    maxSizeWarning: "the file cannot exceed 200M",
    reminderContent: "re uploading can overwrite the current file",
    express: "tracking number",
    expressCompany: "express  company",
    expressDes:
      "if you have not uploaded the. stl file, you can send us the dental model by express delivery. After receiving the dental model you sent, we will process your case as soon as possible",
    expressList: [
      {
        id: 1,
        value: "sf-express",
        label: "sf-express"
      },
      {
        id: 7,
        value: "debang",
        label: "debang"
      },
      {
        id: 2,
        value: "EMS",
        label: "EMS"
      },
      {
        id: 3,
        value: "Yuantong",
        label: "yuantong"
      },
      {
        id: 4,
        value: "sto",
        label: "sto"
      },
      {
        id: 5,
        value: "Zhongtong",
        label: "zhongtong"
      },
      {
        id: 6,
        value: "Yunda",
        label: "yunda"
      }
    ],
    expressTip: "please enter the correct format of the tracking number",
    submitTip:
      "if you need to submit after saving the case Please click the submit case button in the case list"
  },
  photoUpload: {
    facePhoto: "facial photos",
    // fullFace: '正面照',
    fullFace: "front face (default patient profile picture)",
    fullFace1: "",
    fullFaceSmile: "positive smiling photo",
    side45: "45 ° side view",
    side90: "90 ° side view",
    intraoral: "oral photo",
    maxillary: "maxillary",
    maxLeft: "left",
    maxRight: "right side",
    maxOpening: "opening",
    mandible: "mandibular",
    lateralXray: "side X-ray",
    positiveXray: "front X-ray",
    uploadFileText: "upload failed, please try again!",
    uploadSuccess: "upload successful",
    rotateSuccess: "rotation successful",
    XRay: "X-ray photograph",
    sideXPhoto: "skull lateral positioning film",
    panoramicXPhoto: "panoramic sectional film of the entire mandible",
    full: "normal position",
    upper: "maxillofacial photography",
    down: "mandibular and maxillofacial photography",
    left: "left side position",
    right: "right lateral",
    turnForward: "click to rotate the image clockwise",
    turnReverse: "click on the reversible clockwise rotation of the image",
    errorMsg: ["image upload error", "image server error"],
    file: "photo",
    formatErrText:
      "the format is incorrect, please upload JPG,png,bmp Format of photos.",
    lateralPosition: "right side face",
    frontalBite: "front biting photo",
    rightBite: "right side bite photo",
    leftBite: "left side bite photo",
    photoNoUpload: "the medical record has not uploaded this photo yet"
  },
  patientList: {
    state: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending acceptance" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "doctor verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      {
        key: "42",
        stateContent: "delivery completed, awaiting next"
      },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    // 默认
    stateCaseListOnShow: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending acceptance" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "pending doctor's verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      { key: "42", stateContent: "awaiting next" },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    // 医生
    stateCaseListOnShow_doctor: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending cases" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "pending doctor's verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      { key: "42", stateContent: "awaiting next" },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    // 审核
    stateCaseListOnShow_verify: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending acceptance" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "pending doctor's verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      { key: "42", stateContent: "awaiting next" },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    // 数据审核
    stateCaseListOnShow_dataverify: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending cases" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "pending doctor's verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      { key: "42", stateContent: "awaiting next" },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    // 专家
    stateCaseListOnShow_expert: [
      { key: "0", stateContent: "data missing" },
      { key: "4", stateContent: "STL pending" },
      { key: "6", stateContent: "the tracking number has been filled in" },
      { key: "8", stateContent: "pending upload" },
      { key: "10", stateContent: "pending cases" },
      { key: "11", stateContent: "technician supervisor rejects" },
      { key: "12", stateContent: "pending assignment" },
      { key: "15", stateContent: "model processing" },
      { key: "18", stateContent: "designing" },
      { key: "20", stateContent: "DIY solution manufacturer verification" },
      { key: "21", stateContent: "DIY solution rejected by manufacturer" },
      { key: "24", stateContent: "pending expert’s verification" },
      { key: "25", stateContent: "expert rejection" },
      { key: "27", stateContent: "pending doctor's verification" },
      { key: "28", stateContent: "doctor rejects" },
      { key: "30", stateContent: "pending verification" },
      { key: "32", stateContent: "DIY prod verication" },
      { key: "33", stateContent: "DIY plan production rejected" },
      { key: "35", stateContent: "prepare for production" },
      { key: "37", stateContent: "producing" },
      { key: "40", stateContent: "shipping" },
      { key: "42", stateContent: "awaiting next" },
      { key: "44", stateContent: "delivered" },
      { key: "46", stateContent: "restarted" },
      { key: "50", stateContent: "completed" }
    ],
    casePlan: [
      "invisalign",
      "lingual orthodontics",
      "no treatment plan selected"
    ],
    kmFilterStateDoctor: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending upload",
        value: 1,
        filter: [0, 4, 6, 8, 11]
      },
      {
        label: "pending acceptance",
        value: 2,
        filter: [10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 24, 25, 28]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [27, 30]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 21, 32, 33, 35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenter: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterDoctor: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 24, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [27]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterExpert: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "expert verification",
        value: 5,
        filter: [24]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [27]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterProduce: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "confirm production",
        value: 9,
        filter: [35]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterDeliver: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "confirm shipment",
        value: 9,
        filter: [37]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 35]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterSupervisor: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11]
      },
      {
        label: "pending acceptance",
        value: 10,
        filter: [10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "producing",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterVerify: [
      {
        label: "all",
        value: 0,
        filter: []
      },
      {
        label: "pending design",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      {
        label: "designing",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "pending verification",
        value: 4,
        filter: [24, 27, 30, 20, 32]
      },
      // {
      //   label: "confirm the plan",
      //   value: 9,
      //   filter: [20, 32]
      // },
      {
        label: "producing",
        value: 6,
        filter: [35, 37]
      },
      {
        label: "in treatment",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "completed",
        value: 8,
        filter: [50]
      }
    ],
    kmCaseListStateDoctor: [
      "pending upload",
      "pending acceptance",
      "designing",
      "pending verification",
      "in treatment",
      "producing",
      "completed"
    ],
    kmCaseListStateDesignCenter: [
      "pending design",
      "designing",
      "pending verification",
      "producing",
      "in treatment"
    ],
    caseClassification: [
      {
        key: "1",
        stateContent: "teenagers (8-18 years old)"
      },
      {
        key: "2",
        stateContent: "adults (18-35 years old)"
      },
      {
        key: "3",
        stateContent: "middle aged and elderly (over 35 years old)"
      },
      {
        key: "4",
        stateContent: "anshi Class I"
      },
      {
        key: "5",
        stateContent: "anshi Class II"
      },
      {
        key: "6",
        stateContent: "anshi Class III"
      },
      {
        key: "7",
        stateContent: "extract a tooth"
      },
      {
        key: "8",
        stateContent: "remove the incisor"
      },
      {
        key: "9",
        stateContent: "molars distalization"
      },
      {
        key: "10",
        stateContent: "molar mesialization"
      },
      {
        key: "11",
        stateContent: "open jaw"
      },
      {
        key: "12",
        stateContent: "deep overlay, deep overbite"
      },
      {
        key: "13",
        stateContent: "posterior teeth crossing the jaw"
      },
      {
        key: "14",
        stateContent: "tooth arch deviation"
      },
      {
        key: "15",
        stateContent: "periodontal disease"
      }
    ],
    action1: {
      "0": "upload",
      "4": "upload",
      "6": "upload",
      "8": "submit case",
      "10": "accept",
      "11": "",
      "12": "allocation",
      "18": "",
      "20": "verify",
      "21": "",
      "24": "verify",
      "25": "",
      "27": "verify",
      "28": "",
      "30": "produce",
      "32": "verify",
      "33": "",
      "35": "confirm",
      "37": "deliver",
      "40": "shipping",
      "42": "produce",
      "44": "complete",
      "46": "",
      "50": ""
    },
    action1Doctor: {
      "0": "upload",
      "4": "upload",
      "6": "upload",
      "8": "submit case",
      "10": "",
      "11": "",
      "12": "",
      "18": "",
      "20": "",
      "21": "",
      "24": "",
      "25": "",
      "27": "verify",
      "28": "",
      "30": "produce",
      "32": "",
      "33": "",
      "35": "",
      "37": "",
      "40": "shipping",
      "42": "produce",
      "44": "complete",
      "46": "",
      "50": ""
    },
    action1Produce: {
      "0": "",
      "4": "",
      "6": "",
      "8": "",
      "10": "",
      "11": "",
      "12": "",
      "18": "",
      "20": "",
      "21": "",
      "24": "",
      "25": "",
      "27": "",
      "28": "",
      "30": "",
      "32": "verify",
      "33": "",
      "35": "confirm",
      "37": "deliver",
      "40": "",
      "42": "",
      "44": "",
      "46": "",
      "50": ""
    },
    action1Judge: {
      "4": "addInfoCaseBtn",
      "8": "submitCaseBtn",
      "10": "acceptCaseBtn",
      "12": "allocateCaseBtn",
      "20": "diyTpAuditBtn",
      "24": "expertAuditBtn",
      "27": "doctorAuditBtn",
      "30": "startProductBtn",
      "32": "diyTpAuditBtn",
      "35": "confirmProductBtn",
      "37": "orderShipmentBtn",
      "40": "confirmReceiptBtn",
      "42": "startProductBtn",
      "44": "completeBtn"
    },
    action2: {
      "10": "reject",
      "12": "accept",
      "20": "reject",
      "24": "",
      "27": "",
      "32": "reject",
      "42": "restart",
      "44": "restart"
    },
    action2Doctor: {
      "10": "",
      "12": "",
      "20": "",
      "24": "",
      "27": "",
      "32": "",
      "42": "restart",
      "44": "restart"
    },
    action2Produce: {
      "10": "",
      "12": "",
      "20": "",
      "24": "",
      "27": "",
      "30": "reject",
      "32": "reject",
      "42": "",
      "44": ""
    },
    action2Judge: {
      "10": "deniedCaseBtn",
      "12": "getCaseBtn",
      "20": "diyTpDeniedBtn",
      "32": "diyTpDeniedBtn",
      "42": "stageAdjustmentBtn",
      "44": "stageAdjustmentBtn"
    },
    actionTips: {
      "21": "collect the current case and entrust it to oneself for processing",
      "8": "confirm submission of the case",
      "10": "confirm receipt of the case",
      "20": "confirm the approval of the plan",
      "30": "confirm the production of this case",
      "32": "confirm the approval of the plan",
      "35": "confirm the production of this case",
      "40": "confirm receipt",
      "44": "confirmed completion of case modification"
    },
    actionTips1: {
      "20": "confirm rejection of the proposal",
      "30": "confirm rejection of the proposal",
      "32": "confirm rejection of the proposal"
    },
    actionTitle: {
      "12": "collect medical cases",
      "8": "submit",
      "30": "producing",
      "35": "confirm",
      "37": "arrange shipment",
      "40": "shipping",
      "42": "producing"
    },
    archTypeContent: ["maxillary", "mandibular"],
    expressNum: "please enter the tracking number",
    batchSending: "send in batches",
    courierNumber: "tracking number ",
    expressBatchTip: "values between 1-100",
    firstLogTip: "got it",
    manAndMaxSteps: ["maxillary steps", "mandibular steps"],
    placeholderSteps: "step",
    manAndMaxNum: ["number of maxillary", "number of mandibular"],
    placeholderNum: "quantity",
    emailTitle: "send email"
  },
  easyCause: {
    title: "ALIGNER DESIGN SHEET",
    easyCode: "scan the QR code on WeChat to view on your phone",
    middle: {
      orthodonticSelect: "proposed dental arch arrangement",
      orthodonticNum: ["complete", "maxillary", "mandibular"],
      extraction: "extraction",
      anchorage: "anchorage",
      centerLine: "center line",
      overbite: "overbite",
      cover: "overjet",
      molar: "molar relationship",
      crowding: "dental crowding",
      moveAngle: "step translation & rotation",
      notShow: "unfilled"
    },
    right: {
      removable: "immovable teeth",
      adhesive: "non adhesive attachment position",
      reserved: "need to reserve gap teeth position",
      enamel: "do not unglaze adjacent teeth",
      corrected: "orthodontic treatment"
    },
    markers: "tooth position marking",
    modalTitle: "case report",
    modalContent:
      "please confirm if the information on the medical record is correct",
    gender: ["male", "female"],
    htmlTile: "ALIGNER DESIGN SHEET",
    fujian: [
      {
        label: "1",
        value: "default attachment bonding position"
      },
      {
        label: "2",
        value: "attachment bonding position"
      }
    ],
    need: [
      {
        label: "1",
        value: "need"
      },
      {
        label: "2",
        value: "NOT REQUIRED"
      }
    ]
  },
  threeDisplayContent: {
    approveButtonContent: "verify",
    approveWindowTitle: "verify",
    approvedResult: "conclusion",
    approveOperateBtn: ["cancel", "ok"],
    seeAllItem: "aLL",
    radioButtonItemLabOfTooth: [
      {
        label: "crown",
        value: "crownInfo"
      }
      // {
      //   label: "impedance",
      //   value: "impedance"
      // },
      // {
      //   label: "root tip",
      //   value: "rootTip"
      // }
    ],
    toothMove: [
      "mesial",
      "distal",
      "lips facing",
      "tongue direction",
      "rise",
      "depress",
      "translation",
      "reverse",
      "axis tilt",
      "torque",
      "cheek direction"
    ],
    toothMoveOfArchTitleTabs: [
      {
        label: "maxillary",
        value: 0
      },
      {
        label: "mandibular",
        value: 1
      }
    ],
    stepPlanIntroOfArchTitleTabs: [
      {
        label: "maxillary",
        value: 0
      },
      {
        label: "mandibular",
        value: 1
      }
    ],
    approveStatusLab: [
      "approved",
      "demonstrate",
      "fail",
      "pending verification"
    ],
    historicalTpTitle: "record",
    exportTitle: "export",
    exportOperateBtn: ["cancel", "export"],
    shareConfigTitle: "share",
    shareOperateBtn: ["cancel", "create a sharing link"],
    shareSuccessDialogBtn: ["close", "copy"],
    imageDocTitle: "patient photos",
    patientsDemand: "complaints",
    planContent: "diagnostic information",
    treatmentPlan: "treatment",
    uploadCTDile: "upload CT file (zip, rar, 7z files only)",

    designDetailTitle: "design detail",
    boltonPageTitle: "bolton analysis (mm)",
    boltonPageContent: ["tooth width (mm)"],
    stepIntroPageTitle: "staging chart",
    correctionInstructionPageTitle: "correction instruction",
    orderNumber: "case ID:",
    patientName: "patient",
    designDate: "design date",
    treatmentSteps: "total steps",
    stepsLab: ["maxillary", "mandibular"],
    operateNotice: "clinical instructions",
    stepNumLab: ["clause", "step"],
    tpDetailLab:
      "From this step, attachments to be bonded to the following teeth:",
    iprDetailLab: [
      "Before this step, IPR to be performed on the following teeth:",
      "between:"
    ],
    attachmentPicLab: "paste attachment distribution map",
    iprPicLab: "step by step diagram for adjacent surface glazing",
    stepMaskLab: "step",
    iprStepMaskLab: "step ahead",
    stepIntroMarksList: [
      {
        label: "attachment placement",
        value: "pasteAttach",
        icon: "ico_paste_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "attachment removal",
        value: "removeAttach",
        icon: "ico_remove_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "attachment replacement",
        value: "replaceAttach",
        icon: "ico_replace_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "immovable",
        value: "notMove",
        icon: "ico_not_move_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "IPR",
        value: "ipr",
        icon: "ico_ipr_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "bite jump",
        value: "biteJump",
        icon: "ico_bite_jump_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "missing/extracted tooth",
        value: "toothExist",
        icon: "ico_tooth_exist_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "tooth movement",
        value: "toothMove",
        icon: "ico_tooth_move_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "node",
        value: "stage",
        icon: "ico_flag_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: false
      }
    ],
    toothMovePos: ["translation", "rotation", "tip", "torque"],
    toothDataOptions: [
      "extrude (E)/intrude (I) mm",
      "buccal (B)/lingual (L) mm",
      "mesial (M)/distal (D) mm",
      "mesial (M)/distal (D) ",
      "buccal (B)/lingual (L) ",
      "mesial (M)/distal (D) "
    ],
    tpNoticeLab: "simulation plan, actual treatment effect may vary"
  },
  caseDetail: {
    navigateList: [
      {
        label: "patient homepage",
        value: "detailHome",
        icon: "",
        enable: false
      },
      {
        label: "image data",
        value: "imageDocument",
        icon: "ico_image_document",
        enable: true
      },
      {
        label: "digital model",
        value: "digitalModule",
        icon: "ico_digital_module",
        enable: true
      },
      {
        label: "plan management",
        value: "tpManager",
        icon: "ico_tp_manager",
        enable: true
      },
      {
        label: "design detail",
        value: "designDetail",
        icon: "ico_design_detail",
        enable: true
      },
      {
        label: "3D design description",
        value: "tpIntro",
        icon: "ico_tp_intro",
        enable: true
      },
      {
        label: "produce order",
        value: "alignerProcess",
        icon: "ico_aligner_process",
        enable: true
      },
      {
        label: "bill details",
        value: "billingDetails",
        icon: "ico_billing_detail",
        enable: true
      },
      {
        label: "case progress",
        value: "caseProgress",
        icon: "ico_case_progress",
        enable: true
      },
      {
        label: "CT file download",
        value: "ctFilesDownload",
        icon: "ico_ct_files_download",
        enable: true
      }
    ],

    caseId: "case ID:",
    clinic: "hospital/clinic:",
    treatment: "treatment:",
    birth: "date of birth:",
    birth2: "date of birth",
    diagnosisInfo: "diagnostic information:",
    tpListTabTitle: "3D plan design",
    more: "more",
    tpListEmpty: "3D design proposal has not been created yet",
    alignerProcessingStatus: "processing status of orthodontic appliances",
    recentProduce: "recently produced",
    quickNavTitle: "quick query",
    caseStageTitle: "case progress",
    stageListMore: "view the progress of all cases",
    designDetailTitle: "design detail",
    downloadWithPDF: "download PDF",
    tpIntroHtmlTitle: "treatment overview report",
    orthodonticProcessListTab: "recent production records",
    picExplorer: "image viewer",
    imageDoc: "image data",
    xRayFile: "X-ray film",
    otherFile: "OTHERS",
    submitProduce: "submit production",
    btnSubmitProduce: "submit production",
    produceAligner: "produce 10 sets of orthodontic appliances again",
    alignerSendIntro:
      "10 sets of orthodontic appliances will be shipped by default per shipment",
    alignerReceiveAddr: "address for receiving orthodontic appliances:",
    submitIntro:
      "*after submission, it cannot be changed. if you need special instructions or modify the address, please contact customer service.",
    cancelContent: "cancel",
    wearRecord: "record of wearing aligners",
    wearStartDateLab: "start date of wearing",
    wearStartStepLab: "current start step of wearing",
    wearStartStepLab1: "current start step of wearing(maxillary)",
    wearStartStepLab2: "current start step of wearing(mandibular)",
    wearDurationLab: "valid time per piece of aligner",
    submitContent: "ok",
    processPlanTab: "do you want to now?",
    btnProduceContent: "produce 10 more sets",
    stageAdjustLab: "conduct restart",
    produceHeaderLab: "produce",
    wearStepLab: "on step:",
    wearDaysLab: ["available for", "day"],
    producedLab: "produced",
    totalStepsLab: "total steps",
    imageInfosLab: [
      "front",
      "front smile",
      "right",
      "front bite",
      "upper",
      "lower",
      "left",
      "right",
      "X-ray film",
      "lateral cephalometrics",
      "panoramic radiography",
      "other images"
    ],
    addWearDate: "add wearing date",
    btnAddWearInfo: "click add",
    errorMsg: "the user does not have this permission",
    tpApprove: ["pending verification", "fail", "verified"],
    downloadFile: "download file",
    downloadDesignDetailTitle: "ALIGNER DESIGN SHEET",
    downloadTpIntroTitle: "ORTHODONTIC INSTRUSTIONS",
    schemeReportInfoTitle: "treatment overview report",
    orthodonticProcessItem: [
      "production submission",
      "producing",
      "shipping",
      "received",
      "wear on"
    ],
    processStageContent: ["total", "steps"],
    wearRecordPlaceholder: ["select date", "what step is it", "days"],
    wearRecordSubmitAlert: [
      "the number cannot be negative",
      "the current starting step for wearing should be between",
      "and",
      "between",
      "keywords cannot be empty",
      "the wearing period cannot be less than"
    ],
    correctionType: [
      "no treatment plan selected",
      "invisalign",
      "lingual orthodontics"
    ],
    stageAdjust: "restart",
    alignerProduce: "produce",
    designDetail: {
      orderNumber: "case ID:",
      company: "hospital/clinic",
      doctor: "doctor",
      address: "address",
      telephone: "mobile phone",
      patientName: "patient",
      patientsDemand: "complaints",
      customer: "doctor",
      date: ["Y", "M", "D"],
      receiver: "receiver",
      orderDate: "receive date",
      checker: "approved by",
      checkDate: "approval date",
      gender: "gender",
      birthday: "age",
      plan: "treatment",
      orthodonticTreatment: "treatment",
      planContent: "diagnostic information",
      senderAddress: "shipping address",
      consignee: "addressee:"
    }
  },
  alignerProcess: {
    diaphragmSpecificationOpts: [
      {
        label: "standard",
        value: 1
      },
      {
        label: "upgraded",
        value: 2
      },
      {
        label: "deluxe",
        value: 3
      }
    ],
    alignerLabel: "aligner",
    retainerLabel: "retainer",
    alignerEditionOpts: [
      { label: "standard (single TPU, 0.76mm)", value: 1 },
      { label: "upgraded (composite TPU, 0.76mm)", value: 2 },
      { label: "deluxe (multi-layer PTP)", value: 3 }
    ],
    diaphragmThicknessOpts: [
      { label: "0.50mm", value: 3050 },
      { label: "0.63mm", value: 3063 },
      { label: "0.76mm", value: 3076 },
      { label: "1.00mm", value: 3100 }
    ],
    retainerThicknessOpts: [
      { label: "1.00mm", value: 4100 }
    ],
    coverWisdomTeethOpts: [
      {
        label: "yes",
        value: 1
      },
      {
        label: "no",
        value: 2
      }
    ],
    edgeFormOpts: [
      {
        label: "scallop",
        value: 1
      },
      {
        label: "straight",
        value: 2
      }
    ],
    edgeHeightOpts: [
      {
        label: "untouched",
        value: 1
      },
      {
        label: "cover margin by 0-1mm",
        value: 2
      }
    ]
  },
  // 创建病历
  createCase: {
    length: "length",
    nameInputError:
      "Only contain Chinese characters, English letters and numbers",
    nameLengthError: "Less than 30 characters",
    quicklyCreate: "quick creation",
    zizhu: "autonomous",
    DIY: "DIY",
    basicInfo: "basic information",
    name: "name",
    sex: "gender",
    mainDoctor: "attending doctor",
    hospitalName: "hospital/clinic",
    addressTip:
      "Hospital/clinic will be filled in automatically after selecting address above.",
    mailingAddress: "mailing address",
    mailingAddressInfo: [
      "recipient name",
      "recipient mobile number",
      "hospital/clinic",
      "postal code",
      "to address",
      "default address"
    ],
    uploadDigitalModel: "upload digital model",
    tipA: "Please send us gypsum models if fails to upload digital ones.",
    clickHere: "Click here",
    gender: ["male", "female"],
    tipB: "to switch delivery method.",
    addNewAddress: "add",
    upload: ["upload", "file name", "upload progress", "operation", "delete"],
    mailingModel: "mailing model",
    tipC: "If you can upload a digital model,",
    tipD: "switch to the 'upload digital model' method.",
    createCaseBtn: ["cancel", "create", "restart", "ok"],

    doctorEmpty: "Doctor name is empty, please select the treating doctor",
    createCaseSuccess: "successfully created case",
    updateCaseSuccess: "case edited successfully",
    restartCaseSuccess: "case restart successful"
  },
  //亚楠
  detailvue_Case_info: {
    crowdding: "crowdding",
    sparse: "sparse",
    overbite: "overbite",
    overjet: "overjet",
    class_II_I: "class II, division 1",
    class_II_II: "class II, division 2",
    class_III: "class III",
    edge_to_edge_bite: "edge-to-edge bite",
    open_bite: "open bite",
    anterior_crossbite: "anterior crossbite",
    posterior_crossbite: "posterior crossbite",
    narrow_dental_arch: "narrow dental arch",
    gingival_inflammationl: "gingival inflammation",
    oral_inflammation: "oral inflammation",
    osteoporosis: "osteoporosis",
    TMJ_disorders: "TMJ disorders",
    protrusion: "protrusion",
    inadequate_smile_line: "inadequate smile line",
    deformed_teeth: "deformed teeth",
    other: "other",
    molar_distalization: "molar distalization",
    molar_mesialization: "molar mesialization",
    IPR: "IPR",
    anterior_intrusion: "anterior intrusion",
    posterior_intrusion: "posterior intrusion",
    anterior_extrusion: "anterior extrusion",
    posterior_extrusion: "posterior extrusion",
    anterior_teeth_proclination: "anterior teeth proclination",
    bite_guard: "bite guard",
    arch_constriction: "arch constriction",
    posterior_lingual_inclination: "posterior lingual inclination",
    posterior_buccal_inclination: "posterior buccal inclination",
    derotation: "derotation",
    class_III_elastics: "class III elastics",
    extraction_of_third_molars: "extraction of third molars"
  },

  //设计中心
  yulanDesignCenter: "uAlign AI design center",
  otherDesignCenter: "Other Design Center",
  三维展示区: "preview",
  登录: "",
  AI重塑正畸生态: "Revolutionize AI orthodontic ecosystem",
  让医疗回归本质: "Return to the essentiality of medical",
  与正畸医生同行: "Pace forward with orthodontist",
  使用微信扫一扫: "scan with WeChat",
  申请软件试用: "for trail",
  找回密码: "retrieve password",
  成为医生: "become a uAlign doctor",
  返回登录页面: "return to the login page",
  重置密码: "reset password ",
  请填写您需要找回的账号: "please fill in the account you need to retrieve",
  短信验证: "SMS verification",
  验证码已经发送至: "Verification code has been sent to",
  验证码错误: "Verification code error",
  请重新输入: "please re-enter",
  新密码: "new password",
  设置您的新密码并再次确认: "set your new password and confirm again",
  两次密码不一致: "the two passwords are inconsistent",
  成功: "success",
  已为您的账号完成密码重置:
    "password reset has been completed for your account",
  立即登录: "sign in now",
  我们使用和其他跟院技术:
    "we use cookies and other hospital following technologies",
  用于改善网页监体验提供性化内容和广告:
    "used to improve web monitoring experience, provide sexual content and advertising",
  和优化网页功能: "and optimize web functions",
  阅读将私条款和用户使用协议以下统称条款: `Read the private terms and user use agreement hereinafter collectively referred to as "terms"`,
  同意: "agree",
  了解更多: "learn more",
  表示您同意:
    "continuing means that you agree to our use of the aforementioned technology and terms and conditions",
  备案号: "record number",
  矫治器制作单2: "manufacturing order",
  矫治器制作单: "MANUFACTURING ORDER",
  牙套佩戴记录: "record of wearing aligners",
  生产记录: "production progress",
  文件名称: "file name",
  上传时间: "uploaded",
  操作: "operation",
  下载: "download",
  删除: "delete",
  修改: "edit",
  查看全部: "all",
  方案管理: "plan management",
  暂无数字模型方案: "no plans available currently",
  矫治情况: "status",
  最近矫治器生产情况: "recent progress of production",
  步前: "atep ahead",
  添加佩戴日期: "add wearing date",
  其他临床操作说明: "other clinical operation instructions",
  粘贴附件分步图: "attachment placement chart",
  邻面去釉分步图: "IPR chart",
  工作台: "dashboard",
  患者详情: "patient details",
  患者姓名: "patient name",
  将病例:
    "Assign the case to either technician or doctor for processing and designing.",
  技工列表: "technician list",
  医生列表: "doctor list",
  专家列表: "expert list",
  将病例交由该专家: "Submit the design to selected expert for verification.",
  取消: "cancel",
  提交: "submit",
  智上悠蓝: "uAlign AI",
  提交智上悠蓝: "submit to uAlign AI",
  绘制未来: "let’s draw the future",
  立即参与: "join now",
  悠蓝智绘: "uAlign AI",
  个人中心: "my profile",
  退出登陆: "log out",
  病例类型: "case type",
  选择委托设计方: "select a design center",
  收件地址: "address",
  添加新地址: "add",
  顺时针: "clockwise",
  逆时针: "anticlockwise",
  水平翻转: "flip horizontal",
  垂直翻转: "flip vertical",
  生产详细: "details",
  生产步数: "step",
  上颌: "maxillary",
  数量: "quantity",
  下颌: "mandibular",
  附件模板: "attachment template",
  被动矫治器: "passive aligner",
  alignerPassiveAligner: "passive aligner",
  保持器: "retainer",
  数据合计: "total data",
  仅输出数据: "output STL only",
  发送邮箱: "send email",
  膜片规格: "product series",
  期望生产完成日期: "expected date on delivery",
  生产批号: "batch number",
  加工生产: "production",
  导出数据: "export data",
  加工要求: "process requirements",
  矫治器是否覆盖智齿: "cover wisdom tooth",
  矫治器边缘形态: "cutting line",
  矫治器位于牙龈缘高度: "distance between cutting line and margin",
  门诊: "hospital",
  医生: "doctor",
  下单时间: "order time",
  总步数: "total steps",
  总数: "total",
  矫治器: "aligner",
  附件模版: "attachment template",
  完成时间: "expected date on delivery",
  收件人: "recipient",
  联系方式: "phone",
  提交后无法更改如需特殊说明:
    "Please contact customer service if instruction or address edit is required due to the form can’t be edited after submission.",
  提交病例: "submit",
  可佩戴: "available for",
  天: "days",
  新建病例: "new case",
  来源: "source",
  性别: "gender",
  临床诊断信息: "diagnostic information",
  矫正方法: "treatment",
  方案说明: "comments",
  专家审核: "expert verification",
  专家审核中: "expert verification in progress",
  医生审核: "doctor verification",
  医生审核中: "under medical verification",
  添加邮寄地址: "add mailing address",
  用户名: "user name",
  修改用户名: "edit",
  修改密码: "edit",
  登录密码: "login password",
  手机: "mobile phone",
  修改手机: "edit",
  邮箱: "email",
  修改邮箱: "edit",
  退出登录: "log out",
  帐号状态: "account status",
  编辑: "edit",
  管理寄送地址: "shipping address",
  保存: "save",
  邮寄地址: "mailing address",
  轻松创建分享链接: "easily create sharing links",
  一键分享动画方案: "one click sharing of animation",
  新方案: "new feature [3D solution sharing]",
  让远程方案演示:
    "makes remote demonstrations and communication more convenient",
  了解详细: "learn more",
  设计中心病例: "design center",
  累计: "total",
  例: "",
  我的账单: "my bill",
  查看更多: "see more",
  我的U币: "my U coin",
  累计收益: "cumulative income",
  累计支出: "cumulative expenses",
  牙套生产: "produced aligners",
  设计订单: "design order",
  相关应用工具: "related application tools",
  桌面端下载: "desktop download",
  病例管理小程序: "Case Management Applet",
  手机客户端: "uploading, viewing, reviewing supported on mobile.",
  微信小程序: "Scan to enter WeChat Applet",
  分析: "analysis",
  全设计方案:
    "full design plan 20073117: The short movement effect of the dental crown is uncertain. Please pay attention to the movement during clinical orthodontics and the eruption of wisdom teeth. If it affects movement, please choose a clinical date to remove it. during the orthodontic process, please pay attention to checking whether the adjacent teeth are too tight",
  必要时需砂条松解: "if necessary, loosen the sand strip",
  尤其是扭转牙:
    "especially for twisted teeth, please pay attention to checking whether the adjacency is too tight in the near, far, middle, and middle regions",
  尤其是扭转牙的近远中:
    "especially for twisting teeth in the near, far, and mid range",
  模拟方案: "simulation plan",
  实际治疗效果可能不同: "the actual treatment effect may vary",
  查看方案: "View the plan",
  上海悠蓝智绘技术有限公司版权所有:
    "Shanghai uAlign AI Technology Co., Ltd. Copyright",
  留言: " comments",
  订单号: "case ID.",
  备注视频输出到:
    "Note: video (GIF) will be downloaded to the default folder of browser.",
  视角: "angle of view",
  显示: "display",
  步骤: "step",
  速度: "speed",
  当前: "current",
  动画生成中: "animation generation in progress",
  合成中: "in synthesis",
  复制: "copy",
  公开分享方案: "sharing plan (activated)",
  开启分享后获得链接:
    "Upon enabling the sharing feature, any holder of the link and corresponding password shall be granted the right to access the plan within the specified validity period.",

  开启分享即视为已知晓并同意接受:
    "The activation shall constitute your acknowledgment and acceptance of the associated risks. Upon deactivation, all share links created previously shall immediately cease to be active.",

  有效时间: "validity period",
  机构: "design center",
  创建成功: "created successfully",
  通过UAlign悠蓝智绘: "Share link of invisible aligner Case ID",
  隐形矫治3D设计方案: "designed by uAlign AI.",
  链接: "link",
  密码: "password",
  点击链接并输入密码查看方案:
    "Access the plan by clicking the link and entering the password. Please be advised that the actual outcome may differ, and do not share the link as it contains personal information",
  关于我们: "about Us",
  悠蓝学院: "Yulan Academy",
  病例编号: "case ID",
  设计者列表: "designer list",
  提交生产: "submit production",
  确认生产: "confirm",
  物流跟踪: "logistics tracking",
  起始步数: "start step",
  结束步数: "end step",
  生产数量: "quantity",
  请输入发送邮箱: "please enter the email to send",
  选择日期: "select date",
  生产批号填写: "fill in the production batch number",
  此处添加备注信息: "add a comments here (less than 260 characters)",
  确定: "ok",
  再次输入: "enter again",
  审核: "auditing",
  请输入: "please enter",
  原密码: "original password",
  重复一次新密码: "repeat the new password",
  修改手机号码: "edit mobile number",
  请输入新的手机号码: "please enter a new mobile number",
  请输入您的登陆密码: "please enter your login password",
  请输入新邮箱地址: "please enter a new email address",
  请输入密码: "please enter the password",
  请输入备注信息: "please enter",
  您没有权限进行此操作: "You do not have permission to perform this operation",
  步: "step",
  下载CT文件失败: "failed to download CT file",
  设计详单: "design detail",
  自主设计病例: "DIY case",
  临时病例: "temporary case",
  年: ".",
  月: ".",
  日: "",
  照片浏览器: "photo browser",
  正面像: "frontal image",
  正面微笑: "a positive smile",
  右侧面像: "right facial image",
  正面咬合像: "frontal occlusal image",
  口内左侧位像: "intraoral left side image",
  口内右侧位像: "intraoral right side image",
  上牙列像: "maxillary dentition",
  下牙列像: "mandibular dentition",
  全颌曲面断层片: "panoramic radiograph",
  头颅侧位定位片: "lateral cephalometric radiograph",
  其他照片1: "other photos-1",
  其他照片2: "other photos-2",
  其他照片3: "other photos-3",
  治疗概况报告: "treatment overview report",
  请选择设计者: "please select a designer",
  请选择专家: "please select an expert",
  医生diy方案数据审核失败: "doctor DIY plan data verification failed",
  全部: "whole",
  工作站: "WORKSTATION",
  // 中文: "chinese",
  确定要退出登陆: "are you sure you want to log out",
  qt对象未获取到: "QT object not obtained!",
  获取设计中心信息失败: "failed to get design center information",
  发送邮箱不能为空: "sending mailbox cannot be empty",
  快递信息不能为空: "express information cannot be empty",
  成功提交生产: "successfully submitted production",
  生产起始步数不能比已完成步数小:
    "Start step shall not be less the completed ones.",
  // "the number of production start steps cannot be less than the number of completed steps",
  生产结束步数不能比已开始步数小:
    "End-step figure should be higher than start-step one.",
  备注字符长度不能超过260: "the length of remark characters cannot exceed 260",
  请输入正确的数字: "please enter the correct number",
  当前视图: "current view",
  正面: "front",
  左视图: "left view",
  右视图: "right view",
  俯视: "looking down",
  多角度: "multi angle",
  手机号码: "mobile number",
  用户名必填: "user name is required",
  手机号码必填: "mobile number is required",
  手机号码格式错误: "mobile number format error",
  新密码必填: "new password required",
  确认密码必填: "confirm password is required",
  密码长度在: "password length is 6-32 bits",
  新密码两次输入不一致: "the new password entered twice is inconsistent",
  其他字符: "other characters",
  患者: "patient",
  病历号: "case ID",
  主诉: "complaint",
  就诊时间: "visit date",
  门诊单位: "hospital/clinic",
  提交时间: "submit date",
  状态: "status",
  设计中心: "design center",
  生产编号字符长度不能超过20:
    "the character length of production number cannot exceed 20",
  病例分配: "case allocation",
  提交病例失败: "submit case failed",
  厂家方案审核失败: "manufacturer plan verification failed",
  确认收货成功: "confirm receipt succeeded",
  操作成功: "operation successful",
  病例领取: "case acceptance",
  医生治疗方案字数不能超过300:
    "the number of words of doctor's treatment plan cannot exceed 300",
  我的病例: "my case",
  患者列表: "my patient",
  患者主诉: "complaints",
  男性: "male",
  男: "male",
  女性: "female",
  女: "female",
  提交方案: "submit plan",
  方案专家审核: "plan expert verification",
  方案医生审核: "doctor verification",
  专家审核未通过: "expert verification failed",
  专家审核通过: "approved by experts",
  方案医生审核未通过: "doctor's verification did not pass",
  方案医生审核通过: "doctor's verification approved",
  发货地址不能为空: "Please select a shipping address.",
  膜片规格必填: "sheet type[required]",
  提交失败: "submission failed",
  期望生产完成日期必填: "expected date on delivery[required]",
  牙套生产信息错误: "false production information of dental braces",
  发送邮箱必填: "sending email is required",
  请输入正确的邮箱地址: "please enter the correct email address",
  数据错误: "data error",
  修改成功: "modification succeeded",
  姓名不能为空: "name cannot be empty",
  请输入中文字或字母: "please enter Chinese characters or letters",
  姓名长度超过40限制: "name length exceeds 40 limit",
  参数错误: "parameter error",
  原密码不能为空: "the original password cannot be empty",
  新密码不能为空: "the new password cannot be empty",
  新的手机号码不能为空: "the new mobile number cannot be empty",
  请输入正确的手机号码: "please enter the correct mobile number",
  邮箱不能为空: "mailbox cannot be empty",
  待收货: "awaiting delivery",
  已收货: "delivered",
  生产提醒: "production remind",
  李菊英: "lijuying",
  吴彦翰: "wuyanhan",
  李思霖: "lisilin",
  你所输入的患者主诉不能超过300字:
    "the patient's chief complaint you input cannot exceed 300 words",
  患者主诉字数不能超过300:
    "the number of patient complaints should not exceed 300",
  保存本地草稿成功:
    "the local draft is saved successfully. You can choose to load it next time you create a case",
  红色号标记的重要信息不能为空: "fill the blank marked red *",
  牙位: "FDI notation",
  附件: "attachment",
  邻面去釉: "IPR",
  网格: "grid",
  叠加: "comparation",
  咬合接触: "bite",
  仅上颌: "maxillary only",
  右侧: "right side",
  仰视: "look up",
  左侧: "left side",
  后视: "backsight",
  仅下颌: "mandibular only",
  没有上颌方案: "no maxillary plan",
  没有下颌方案: "no mandibular plan",
  数据加载失败: "data loading failed",
  初始数据加载失败: "initial data loading failed",
  牙齿文件加载错误: "tooth file loading error",
  第: "page",
  步去釉: "step enamel removal",
  你输入的密码不正确:
    "the password you entered is incorrect. You cannot preview the plan. Please enter the correct password",
  专家: "expert",
  通过: "approve",
  不通过: "reject",
  请选择审核结果: "please select the audit result",
  评审失败: "verification failure",
  慢速: "slow",
  中速: "medium",
  快速: "fast",
  导出步骤格式错误: "export step format error",
  结束步骤不能比开始步骤小:
    "the end step cannot be smaller than the start step",
  技工提交方案: "produce order submitted",
  更多记录: "more records",
  折叠: "fold",
  复制成功: "copy successful",
  天1: "1 day",
  天3: "3 day",
  天7: "7 day",
  不显示: "hide",
  最大步数超过方案步数最大值:
    "parameter error -- the maximum number of steps exceeds the maximum number of plan steps",
  病例资料: "image data",
  分步信息: "staging chart",
  历史方案: "record",
  矫治说明: "orthodontic instruction",
  分享: "share",
  导出: "export",
  方案初始化错误: "plan initialization error",
  牙齿初始化错误: "tooth initialization error",
  牙龈初始化错误: "gum initialization error",
  萌出帽初始化错误: "sprouting cap initialization error",
  init数据加载失败: "init data loading failed",
  文件加载错误: "file loading error",
  评审检测错误: "verification detection error",
  设计阶段: "design phase",
  阶段调整: "restart",
  姓名病例号医院: "name, case ID, hospital",
  病例号: "ID",
  确认发货: "package information",
  个: "piece(s)",
  驳回备注: "remarks",
  确认接收改病例: "confirm the acceptance",
  接收病例: "accept case",
  自定义: "customize",
  备注: "remark",
  牵引钩在: "Attachment hook:Place traction hooks on teeth",
  放置牵引钩: ". If production is handled by us, no operation is required on your part.",
  开窗在: "Window opening:Place window openings on teeth",
  放置开窗: ". If production is handled by us, no operation is required on your part.",
  压力嵴在: "Pressure ridge:Place pressure ridges on teeth",
  放置压力嵴: ". If production is handled by us, no operation is required on your part."
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js